export default __webpack_public_path__ + "assets/50n.04c7c2b5.svg";